<template>
  <v-navigation-drawer
    v-model="drawer"
    class="lighten-3 elevation-1"
    :mobile-break-point="991"
    floating
    persistent
    width="260"
    app
  >
    <v-list>
      <div class="container-image-logo mb-3 pl-3">
        <router-link to="/learning/courses">
          <img
            class="mt-2"
            src="@/assets/store_logo/acamy.png"
            alt="logo"
            width="auto"
            height="36px"
          />
        </router-link>
        <v-spacer />
        <v-btn
          v-if="responsive"
          dark
          icon
          flat
          color="primary"
          @click="toggleDrawer"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </div>

      <router-link
        v-for="link in routes"
        :key="link.to"
        class="button button1 py-2"
        :to="link.to"
      >
        <div :class="{ selected: isActive(link.to) }"></div>
        <v-layout row>
          <v-flex xs4 offset-xs1>
            <i
              name="icon"
              :class="link.icon"
              style="fontSize: 2.5rem; color:grey"
            ></i>
          </v-flex>
          <v-flex xs7>
            <div class="ml-1 button-text-container">
              {{ link.name }}
            </div>
          </v-flex>
        </v-layout>
      </router-link>
    </v-list>
    <v-spacer></v-spacer>
    <button class="button button1 py-2" style="position: absolute; bottom: 4vh">
      <v-layout row>
        <v-flex xs7 offset-xs3>
          <div class="ml-1 button-text-container" @click="logout()">
            Cerrar sesión
          </div>
        </v-flex>
      </v-layout>
    </button>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations } from "vuex";
import Role from "@/utils/role";
import CredentialServices from "@/services/Credentials.service.js";
export default {
  data() {
    return {
      responsive: false,
      credentialService: new CredentialServices()
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    routes() {
      if (localStorage.getItem("role") === Role.STUDENT) {
        return [
          {
            name: "Cursos",
            to: "/student/courses",
            icon: "pi pi-book"
          },
          {
            name: "Calificaciones",
            to: "/student/qualification",
            icon: "pi pi-check-circle"
          },
          {
            name: "Eventos",
            to: "/student/events",
            icon: "pi pi-calendar"
          }
        ];
      }
      if (localStorage.getItem("role") === Role.TEACHER) {
        return [
          {
            name: "Cursos",
            to: "/learning/courses",
            icon: "pi pi-book"
          },
          {
            name: "Estudiantes",
            to: "/learning/students",
            icon: "pi pi-users"
          },
          {
            name: "Calificaciones",
            to: "/learning/qualifications",
            icon: "pi pi-check-circle"
          }
        ];
      }

      if (localStorage.getItem("role") === Role.ADMIN) {
        return [
          {
            name: "Cursos",
            to: "/learning/admin/courses",
            icon: "pi pi-book"
          },
          {
            name: "Profesores",
            to: "/learning/teachers",
            icon: "pi pi-briefcase"
          },
          {
            name: "Estudiantes",
            to: "/learning/students",
            icon: "pi pi-users"
          }
        ];
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations(["setDrawer", "toggleDrawer"]),
    isActive(route) {
      return this.$route.path === route;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.drawer = false;
      } else {
        this.responsive = false;
        this.drawer = true;
      }
    },
    logout() {
      this.credentialService.clearCredentials();
      this.$router.push("/auth/login");
    }
  }
};
</script>

<style>
.button1 {
  background-color: white;
  color: #616161;
}

.button1:hover,
.button1.active {
  background-color: #f2f2f2;
  color: black;
}

.selected {
  margin-top: 1px;
  position: absolute;
  background-color: #e64a19;
  right: 0px;
  width: 4.5px;
  height: 43px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.container-image-logo {
  display: flex;
  justify-content: center;
  margin-right: 5px;
}

.button {
  width: 100%;
  background-color: #4caf50; /* Green */
  border: none;
  color: white;
  /* padding: 16px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  transition-duration: 0.4s;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
}

.button-text-container {
  display: flex;
  align-items: center;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Drawer.vue